import instance from "services";

export default GetUserById

async function GetUserById(id: string): Promise<GetUserVyIdResponse> {
    const response = await instance.get(`/v1/backoffice/backoffice-users/${id}`);
    return response?.data?.data;
}
export interface GetUserByIdRequest {
    id: string;
}
export interface GetUserByIdResponseData {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
}

export interface GetUserVyIdResponse {
    success: boolean;
    data: GetUserByIdResponseData;
}
